/** Strings owned by `src/manage/companies/RolePages.tsx` — company-admin,
 * department-admin (coach) and platform-admin role assignment (§ Beheer). */
export const roles = {
  form: {
    person: 'Person',
    choose: 'Choose…',
    grant: 'Grant {{label}}',
    revoke: 'Revoke {{label}}',
    back: 'Back',
  },
  company: {
    title: 'Company admins',
    lead: "A company admin manages this company's own information, departments, members and provisioning. Granting and revoking is audited.",
    label: 'company admin',
    rowsLabel: 'the company members',
  },
  department: {
    title: 'Department admins (coach)',
    lead: "A department admin reads this department's members and aggregates, and — under the individual-access rule — the individual statistics its consent basis covers. Granting and revoking is audited.",
    label: 'department admin',
    rowsLabel: 'the department members',
  },
  admins: {
    title: 'Platform administrators',
    lead: 'A platform admin holds every scoped authority. The target of an appointment must have a login and be a primary identity; the last administrator cannot be retired.',
    name: 'Name',
    email: 'E-mail',
    retire: 'Retire',
    rowsLabel: 'the administrators',
    searchPeople: 'Search people',
    searchPlaceholder: 'Name or e-mail',
    person: 'Person',
    choose: 'Choose…',
    noEligible: 'No eligible person matches — they need a login of their own.',
    appoint: 'Appoint',
    usersLabel: "the platform's users",
  },
} as const;
